import Vue from "vue";

export default {
	extends: Vue,
	props: {
		field: String,
		dataItem: Object,
		format: String,
		className: String,
		columnIndex: Number,
		columnsCount: Number,
		rowType: String,
		level: Number,
		expanded: Boolean,
		editor: String,

		readonly: Boolean,
		disabled: Boolean
	},
	methods: {
		editHandler: function() {
			if (!this.readonly && !this.disabled) this.$emit("edit-gridrow", {dataItem: this.dataItem});
		}
	},
	watch: {
		readonly(value) {
			console.log(value);
		}
	}
};
